import React from 'react';
import { RelayItemPart } from './types';

interface Props {
  parts: Array<RelayItemPart>;
  pixelsPerHour: number;
}

const RelayBackground = (props: Props): React.ReactElement => {
  const { parts } = props;

  return (
    <div className="relay-background--small">
      {parts.map((part, index) => (
        <div key={index} className="part">
          <div
            className="image"
            style={{ backgroundImage: `url(${part.cover_image})` }}
          />
        </div>
      ))}
    </div>
  );
};

export default RelayBackground;
